<template>
  <div class="work-schedule-table">
    <table class="schedule-table">
      <thead>
        <tr>
          <th>Día</th>
          <th>Hora Entrada</th>
          <th>Hora Salida</th>
          <th>Descanso (min)</th>
          <th class="text-center">Día Libre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="dia in diasSemana" :key="dia.key">
          <td class="day-label">{{ dia.label }}</td>
          <td>
            <input
              type="text"
              v-model="localSchedule[dia.key].hora_entrada"
              placeholder="09:00"
              :disabled="localSchedule[dia.key].is_day_off"
              @input="onTimeChange(dia.key)"
              class="time-input"
            />
          </td>
          <td>
            <input
              type="text"
              v-model="localSchedule[dia.key].hora_salida"
              placeholder="17:00"
              :disabled="localSchedule[dia.key].is_day_off"
              @input="onTimeChange(dia.key)"
              class="time-input"
            />
          </td>
          <td>
            <input
              type="number"
              v-model.number="localSchedule[dia.key].descanso"
              placeholder="60"
              min="0"
              max="480"
              :disabled="localSchedule[dia.key].is_day_off"
              @input="onBreakChange(dia.key)"
              class="break-input"
            />
          </td>
          <td class="text-center">
            <input
              type="checkbox"
              v-model="localSchedule[dia.key].is_day_off"
              @change="toggleDayOff(dia.key)"
              class="checkbox-input"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="errorMessage" class="error-message mt-2">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkScheduleTable',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      diasSemana: [
        { key: 'lunes', label: 'Lunes' },
        { key: 'martes', label: 'Martes' },
        { key: 'miercoles', label: 'Miércoles' },
        { key: 'jueves', label: 'Jueves' },
        { key: 'viernes', label: 'Viernes' },
        { key: 'sabado', label: 'Sábado' },
        { key: 'domingo', label: 'Domingo' }
      ],
      localSchedule: {},
      errorMessage: ''
    };
  },
  mounted() {
    this.initializeSchedule();
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.initializeSchedule();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    initializeSchedule() {
      const schedule = {};
      this.diasSemana.forEach(dia => {
        const dayData = this.value && this.value[dia.key] ? this.value[dia.key] : {};
        schedule[dia.key] = {
          hora_entrada: dayData.hora_entrada || '09:00',
          hora_salida: dayData.hora_salida || '17:00',
          descanso: dayData.descanso !== undefined ? dayData.descanso : 60,
          is_day_off: dayData.hora_entrada === null
        };
      });
      this.localSchedule = schedule;
    },
    toggleDayOff(dia) {
      if (this.localSchedule[dia].is_day_off) {
        this.localSchedule[dia].hora_entrada = null;
        this.localSchedule[dia].hora_salida = null;
        this.localSchedule[dia].descanso = 0;
      } else {
        this.localSchedule[dia].hora_entrada = '09:00';
        this.localSchedule[dia].hora_salida = '17:00';
        this.localSchedule[dia].descanso = 60;
      }
      this.emitValue();
    },
    onTimeChange(dia) {
      const entrada = this.localSchedule[dia].hora_entrada;
      const salida = this.localSchedule[dia].hora_salida;

      this.errorMessage = '';

      if (entrada && salida && entrada >= salida) {
        this.errorMessage = `${this.diasSemana.find(d => d.key === dia).label}: La hora de salida debe ser posterior a la hora de entrada`;
      }

      this.emitValue();
    },
    onBreakChange(dia) {
      const descanso = this.localSchedule[dia].descanso;

      this.errorMessage = '';

      if (descanso < 0) {
        this.localSchedule[dia].descanso = 0;
      } else if (descanso > 480) {
        this.localSchedule[dia].descanso = 480;
      }

      this.emitValue();
    },
    emitValue() {
      const horario = {};
      Object.keys(this.localSchedule).forEach(dia => {
        horario[dia] = {
          hora_entrada: this.localSchedule[dia].is_day_off ? null : this.localSchedule[dia].hora_entrada,
          hora_salida: this.localSchedule[dia].is_day_off ? null : this.localSchedule[dia].hora_salida,
          descanso: this.localSchedule[dia].is_day_off ? 0 : (this.localSchedule[dia].descanso || 0)
        };
      });
      this.$emit('input', horario);
    },
    validate() {
      for (const dia of this.diasSemana) {
        const dayData = this.localSchedule[dia.key];
        if (!dayData.is_day_off) {
          const entrada = dayData.hora_entrada;
          const salida = dayData.hora_salida;

          if (!entrada || !salida) {
            this.errorMessage = `${dia.label}: Debe completar ambas horas o marcar como día libre`;
            return false;
          }

          const timeRegex = /^([0-1]\d|2[0-3]):([0-5]\d)$/;
          if (!timeRegex.test(entrada) || !timeRegex.test(salida)) {
            this.errorMessage = `${dia.label}: Formato inválido (HH:MM)`;
            return false;
          }

          if (entrada >= salida) {
            this.errorMessage = `${dia.label}: La hora de salida debe ser posterior a la hora de entrada`;
            return false;
          }
        }
      }
      this.errorMessage = '';
      return true;
    }
  }
};
</script>

<style scoped>
.work-schedule-table {
  margin-top: 16px;
}

.schedule-table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
}

.schedule-table th,
.schedule-table td {
  padding: 8px;
  border: 1px solid #e0e0e0;
  text-align: left;
}

.schedule-table th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #424242;
}

.day-label {
  font-weight: 500;
  min-width: 100px;
}

.time-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}

.time-input:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.time-input:focus {
  outline: none;
  border-color: #7339B7;
  box-shadow: 0 0 0 2px rgba(115, 57, 183, 0.1);
}

.break-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}

.break-input:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.break-input:focus {
  outline: none;
  border-color: #7339B7;
  box-shadow: 0 0 0 2px rgba(115, 57, 183, 0.1);
}

.checkbox-input {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.text-center {
  text-align: center;
}

.error-message {
  color: #d32f2f;
  font-size: 12px;
  font-weight: 500;
  margin-top: 8px;
}
</style>
